import { Box, BoxProps } from "@hightouch/htui";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <Box
      as="path"
      fillRule="evenodd"
      d="M9.42871 11.29C9.07775 10.1189 10.2309 9.01777 11.4043 9.4668H11.4053L21.1592 13.2021C22.3216 13.6477 22.4658 15.2337 21.4043 15.8828L17.9775 17.9766L15.8838 21.4033C15.2346 22.4659 13.6485 22.3206 13.2031 21.1582L9.46777 11.4043L9.42871 11.29ZM14.707 19.4922L16.334 16.8311H16.335C16.459 16.6283 16.6293 16.458 16.832 16.334V16.333L19.4941 14.7061L11.7354 11.7344L14.707 19.4922ZM5.69727 14.8887C6.08779 14.4984 6.72087 14.4983 7.11133 14.8887C7.50153 15.2791 7.50152 15.9123 7.11133 16.3027L6.05078 17.3633C5.66035 17.7537 5.02727 17.7536 4.63672 17.3633C4.24628 16.9728 4.24623 16.3397 4.63672 15.9492L5.69727 14.8887ZM4.5 10C5.05228 10 5.5 10.4477 5.5 11C5.5 11.5523 5.05228 12 4.5 12H3C2.44772 12 2 11.5523 2 11C2 10.4477 2.44772 10 3 10H4.5ZM15.9502 4.63672C16.3407 4.24648 16.9738 4.24636 17.3643 4.63672C17.7544 5.02719 17.7545 5.66033 17.3643 6.05078L16.3037 7.11133C15.9133 7.50176 15.2802 7.50162 14.8896 7.11133C14.4992 6.72079 14.4991 6.08777 14.8896 5.69727L15.9502 4.63672ZM4.63672 4.63574C5.02726 4.24546 5.66034 4.2453 6.05078 4.63574L7.11133 5.69629C7.50153 6.08675 7.50153 6.71989 7.11133 7.11035C6.72089 7.50079 6.08781 7.50063 5.69727 7.11035L4.63672 6.0498C4.24619 5.65928 4.24619 5.02627 4.63672 4.63574ZM11 2C11.5523 2 12 2.44772 12 3V4.5C12 5.05228 11.5523 5.5 11 5.5C10.4477 5.5 10 5.05228 10 4.5V3C10 2.44772 10.4477 2 11 2Z"
      clipRule="evenodd"
    />
  </Box>
);
